/*****************************************************************************/
/*  File Name: passwordResetDialog.js                                        */
/*  Date:      April 25, 2025                                                */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   Dialog to reset users passwords if they have a                */
/*             default password                                              */
/*****************************************************************************/

import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import { getFunctions, httpsCallable } from 'firebase/functions';


import styles from './styles/passwordResetDialog.module.scss';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';


function ChangePasswordDialogAdmin({ openDialog, setOpenDialog }) {

    const [newPassword, setNewPassword] = useState('');
    const [userEmail, setUserEmail] = useState('')
    const [errorNewPassword, setErrorNewPassword] = useState(false);
    const [successNewPassword, setSuccessNewPassword] = useState(false);
    const [errorNewPasswordMessage, setErrorNewPasswordMessage] = useState(null);
    const [changingPassword, setChangingPassword] = useState(false);
    const [changingPasswordMessage, setChangingPasswordMessage] = useState('Changing Password');
    const [changePasswordResult, setChangePasswordResult] = useState(null)

    const functions = getFunctions();
    const updateUserPassword = httpsCallable(functions, 'users-changeUserPasswordAdmin');

    const closeDialog = () => {
        setUserEmail('')
        setNewPassword('');
        setChangePasswordResult(null)
        setChangingPasswordMessage('')
        setOpenDialog(false);
        setChangingPassword(false)
    };

    const resetPassword = () => {
        let pass = false;

        //Check to see if the two emails are long enough - must be 8 characters long
        if (newPassword.length < 8) {
            //console.log('the password must be longer then 8 characters');
            setErrorNewPassword(true);
            setErrorNewPasswordMessage('Password must be at least 8 characters long');
            pass = false;
        } else {
            setErrorNewPassword(false);
            setErrorNewPasswordMessage(null);
            pass = true;
        }

        // We will then save the new passwords
        if (pass) {
            setSuccessNewPassword(true);

            //We will call the https call

            setChangingPassword(true);

            updateUserPassword({ userEmail, newPassword }).then((result) => {
                //console.log('this is my results---- > ', result)
                const resultData = result.data;
                setChangePasswordResult(result.data.success)

                if (resultData.success === false) {

                    setChangingPasswordMessage(resultData.message.errorInfo.message);
                } else {
                    setChangingPasswordMessage(resultData.message);
                }
                //console.log("message -> ", sanitizedMessage);
            });


        }
    };

    const generatePassword = (length) => {
        const charSets = {
            uppercase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
            lowercase: "abcdefghijklmnopqrstuvwxyz",
            numbers: "0123456789",
            symbols: "!@#$%^&*()_+-=[]{}<>/?",
        };

        let availableChars = "";
        availableChars += charSets.uppercase;
        availableChars += charSets.lowercase;
        availableChars += charSets.numbers;
        availableChars += charSets.symbols;

        if (!availableChars) return "";

        let password = "";
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * availableChars.length);
            password += availableChars[randomIndex];
        }

        return password;
    };



    const generatePass = () => {
        setNewPassword(
            generatePassword(12)
        );
    }


    let disable = true;

    disable = userEmail === '' || newPassword === '';

    //console.log("Clinic in add user",clinic);

    return (
        <Dialog open={openDialog} onClose={() => closeDialog()} fullWidth={true} maxWidth='sm'>
            <DialogTitle>
                <Grid item xs container>
                    <Grid item xs={11}>
                        <Typography variant='h6'>Change Users Password</Typography>
                    </Grid>
                    <Grid item xs={1} align='right'>
                        <IconButton onClick={() => closeDialog()}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Grid item xs container spacing={2} alignItems='center' justify='center'>


                    <Grid item xs={12}>
                        <TextField required label='Users Email' name='usersEmail' value={userEmail} id='userEmail' onChange={(event) => setUserEmail(event.target.value)} className={styles.textField} />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={errorNewPassword} color={successNewPassword ? 'success' : 'primary'} variant='outlined' className={styles.textField}>
                            <InputLabel htmlFor='outlined-adornment-password'>New Password</InputLabel>
                            <OutlinedInput
                                id='new-password'
                                type={'text'}
                                value={newPassword}
                                onChange={(event) => setNewPassword(event.target.value)}
                                label='New Password'
                            />
                            <FormHelperText id='new-password-helper-text'>{errorNewPasswordMessage ? errorNewPasswordMessage : 'Password must be at least 8 characters long'} </FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} textAlign={'center'}>
                        {changingPassword ? changingPasswordMessage : ''}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid item xs container>
                    <Grid item xs={4}>
                        <Button onClick={() => closeDialog()}>Cancel</Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => generatePass()}>Generate Password</Button>
                    </Grid>
                    <Grid item xs={4} align='right'>
                        <Button color='primary' disabled={disable} onClick={() => resetPassword()}>
                            Set New Password
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

export default ChangePasswordDialogAdmin;
